var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.68 9.3775C16.38 9.1375 16.9 8.4775 16.98 7.7375C17.03 7.2675 16.93 6.8275 16.7 6.4675L15.42 4.2475C15.23 3.9175 14.75 3.9175 14.55 4.2475L13.27 6.4675C13.1 6.7675 13 7.1175 13 7.4975C13 8.8175 14.3 9.8475 15.68 9.3775ZM19.53 19.4175L18.53 18.4175L17.45 19.4875C16.15 20.7875 13.87 20.7975 12.56 19.4875L11.49 18.4175L10.4 19.4875C9.75 20.1375 8.88 20.4975 7.96 20.4975C7.23 20.4975 6.56 20.2675 6 19.8875V23.4975C6 24.5975 6.9 25.4975 8 25.4975H22C23.1 25.4975 24 24.5975 24 23.4975V19.8875C23.25 20.3975 22.29 20.6375 21.26 20.4075C20.6 20.2675 20.01 19.8975 19.53 19.4175ZM21 12.4975H16V11.4975C16 10.9475 15.55 10.4975 15 10.4975C14.45 10.4975 14 10.9475 14 11.4975V12.4975H9C7.34 12.4975 6 13.8375 6 15.4975V16.9575C6 17.8075 6.5 18.6275 7.31 18.8975C8.04 19.1375 8.83 18.9575 9.34 18.4375L11.48 16.3075L13.61 18.4375C14.37 19.1975 15.62 19.1975 16.38 18.4375L18.52 16.3075L20.65 18.4375C21.08 18.8675 21.68 19.0675 22.3 18.9875C23.29 18.8575 23.99 17.9275 23.99 16.9275V15.5075C24 13.8375 22.66 12.4975 21 12.4975Z",
    fill: "#ADB8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.e6ba0e3f32a7fb9e6023fc0c92563c17.svg";
export { ForwardRef as ReactComponent };